import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class MatrimonioService {
    constructor(private http: HttpClient) { }

    traePostulantes(rut: any) {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }


    buscarHijo(rut: any) {
        return this.http.get(`${environment.urlApiSubsidio}/nacimiento/registroCivil/${rut}`,
            { headers: this.armaCabecera() }).toPromise();
    }

    ingresarMatrimonio(matrimonio: any, fechaUnion: any, idAfiliado: any, idEjecutivo:any) {

        return this.http.post(`${environment.urlApiSubsidio}/solicitud/matrimonio`,
            {
                idUsuario: idAfiliado,
                idCarga: 0,
                idProducto: 9,
                archivoAdjunto: matrimonio.archivo,
                idEjecutivoAsignado:idEjecutivo,
                matrimonio: {
                    tipoUnion: matrimonio.tipoUnion,
                    fechaMatrimonio: fechaUnion,
                    nombreCompletoConyuge: matrimonio.nombreConyugue,
                    rutConyuge: matrimonio.rutConyuge
                }

            },
            { headers: this.armaCabecera() }).toPromise();
    }

    traeTipoMatrimonio() {

        return this.http.get(`${environment.urlApiSubsidio}/getTipoMatrimonio`,
            { headers: this.armaCabecera() }).toPromise();
    }


    editarMatrimonio(data: any, fechaUnion: any,idUsuario: any ,idUsuarioSesion: any) {
       
        return this.http.put(`${environment.urlApiSubsidio}/solicitud/matrimonio`,
            {
                idUsuario: idUsuario,
                id: data.idPostulacion,
                idProducto: 9,
                matrimonio: {
                    tipoUnion: data.tipoUnion,
                    fechaMatrimonio: fechaUnion,
                    nombreCompletoConyuge: data.nombreCompletoConyuge ,
                    rutConyuge: data.rutConyuge
                }
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    armaCabecera() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}